/* eslint-disable no-param-reassign */
import axios from 'axios';
import { NotificationManager } from '@/components/common/react-notifications';
import { getLocale, isProxied } from '@/helpers/Utils';
import {
	getCurrentBranch,
	getCurrentMerchant,
	setCurrentMerchant,
} from '@/helpers/WorkspaceHelper';
import { authUserStorageKey } from '@/configs/main';

const getCurrentUser = () => {
	let user = null;
	try {
		if (window.targetStorage.getItem(authUserStorageKey)) {
			user = JSON.parse(window.targetStorage.getItem(authUserStorageKey));
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> getCurrentUser error:', error);
	}
	return user;
};

const setCurrentUser = (payload) => {
	try {
		if (payload) {
			window.targetStorage.setItem(authUserStorageKey, JSON.stringify(payload));
		} else {
			window.targetStorage.removeItem(authUserStorageKey);
		}
	} catch (error) {
		console.error('>>> src/helpers/Utils.js -> setCurrentUser error:', error);
	}
};

const isLocalUrl = (url) => {
	return url.indexOf('/api') === 0 || url.indexOf('/admin/api') === 0;
};

const client = axios.create({
	timeout: 30000,
});

// Allows Anonymous Access
const allows = [];

// Get resource without special store.
const specialUrls = ['/gateway/echidna-api/api/vs/resource/tob-user-auth'];

client.interceptors.request.use(
	(config) => {
		// Generate base url if request local server api.
		// if (isLocalUrl(config.url)) {
		//   let baseUrl = getBaseUrl() || config.baseURL;
		//   if (!baseUrl) {
		//     baseUrl = window.location.origin;
		//   }
		//   config.baseURL = baseUrl;
		// }
		config.headers['SystemCode'] = 1005;
		config.headers['Timestamp'] = new Date().getTime();
		config.headers['Accept-Language'] = getLocale() || 'en-AU';

		if (!config.headers.Token) {
			if (!allows.includes(config.url)) {
				const user = getCurrentUser();
				if (user) {
					if (user.type === 'local' && !isLocalUrl(config.url)) {
						config.headers['Token'] = user.gatewayToken;
					} else {
						config.headers['Token'] = user.token;
					}
				}
			}
		}

		const mid = getCurrentMerchant()?.merchantId;
		const bid = getCurrentBranch()?.branchId;
		if (mid && !config.headers.MerchantId) {
			config.headers['MerchantId'] = mid;
			if (bid && !config.headers.BranchId) {
				config.headers['BranchId'] = bid;
			}
		}

		if (specialUrls.includes(config.url)) {
			delete config.headers['BranchId'];
		}

		return config;
	},
	(error) => {
		// Do something with request error
		console.error('Axios request error: ', error); // for debug
		Promise.reject(error);
	}
);

client.interceptors.response.use(
	(response) => {
		const res = response.data;
		const code = parseInt(res.Code || res.code, 10);
		if (code || code === 0) {
			if (code === 1000) {
				const result = res.Data || res.data;
				return Promise.resolve(result || true);
			}
			if (code === 1016 || code === 2056) {
				NotificationManager.warning('Authentication failed, please re-login.');
				setCurrentUser(null);
				setCurrentMerchant(null);
				const loginUrl = isProxied() ? '/instore-login' : '/login';
				window.location.href = loginUrl;
			}
			if ('Message' in res) {
				res.message = res.Message;
			}
			return Promise.reject(res);
		}
		return Promise.resolve(response);
	},
	(error) => {
		console.error('Response error: ', error);
		return Promise.reject(error);
	}
);

const get = (url, params = {}, options = {}) => {
	return client({ url, method: 'GET', params, ...options });
};

const post = (url, data = {}, params = {}, options = {}) => {
	return client({ url, method: 'POST', params, data, ...options });
};

const put = (url, data = {}, params = {}, options = {}) => {
	return client({ url, method: 'PUT', params, data, ...options });
};

const del = (url, params = {}, data = {}, options = {}) => {
	return client({ url, method: 'DELETE', params, data, ...options });
};

export default {
	get,
	post,
	put,
	del,
};
